import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';
import AddIcon from '@mui/icons-material/Add';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PersonIcon from '@mui/icons-material/Person';
import CategorySelectionModal from '../InputPages/CategorySelectionModal';

const BottomMenu = ({ onShowSaved, savedActive = false }) => {
  const { language } = useLanguage();
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);

  const getMenuTexts = () => {
    switch (language) {
      case 'TH':
        return { add: 'เพิ่ม', saved: 'ที่บันทึกไว้', profile: 'โปรไฟล์' };
      case 'CN':
        return { add: '添加', saved: '已保存', profile: '个人资料' };
      default:
        return { add: '+', saved: 'Saved', profile: 'Me' };
    }
  };

  const menuTexts = getMenuTexts();

  const menuItems = [
    { key: 'add',     text: menuTexts.add,     icon: <AddIcon /> },
    { key: 'saved',   text: menuTexts.saved,   icon: savedActive ? <BookmarkIcon /> : <BookmarkBorderIcon /> },
    { key: 'profile', text: menuTexts.profile, icon: <PersonIcon /> },
  ];

  const handleMenuClick = (key) => {
    switch (key) {
      case 'add':
        setCategoryModalOpen(true);
        break;
      case 'saved':
        if (onShowSaved) onShowSaved();
        break;
      case 'profile':
        window.open('/dashboard', '_blank');
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#ffffff' }}>
        {menuItems.map(({ key, text, icon }) => (
          <Button
            key={key}
            onClick={() => handleMenuClick(key)}
            sx={{
              py: 2,
              px: 2,
              borderRadius: 0,
              flexDirection: 'column',
              minHeight: 70,
              minWidth: 70,
              color: (key === 'saved' && savedActive) ? '#7c3aed' : '#666',
              borderBottom: key !== 'profile' ? '1px solid #f0f0f0' : 'none',
              backgroundColor: (key === 'saved' && savedActive) ? 'rgba(124,58,237,0.06)' : 'transparent',
              '&:hover': { backgroundColor: (key === 'saved' && savedActive) ? 'rgba(124,58,237,0.10)' : '#f0f0f0' },
              textTransform: 'none',
            }}
          >
            {icon}
            <Box sx={{ fontSize: '0.7rem', mt: 0.5 }}>{text}</Box>
          </Button>
        ))}
      </Box>
      <CategorySelectionModal
        open={categoryModalOpen}
        onClose={() => setCategoryModalOpen(false)}
        language={language}
      />
    </>
  );
};

export default BottomMenu;
